import { useMemo, useState } from "react";
import { Input } from "@/components/ui/input";
import { Search, Plus } from "lucide-react";

export function MenuSearch({ items, sym, onAdd }) {
  const [q, setQ] = useState("");
  const hits = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return [];
    return items.filter((m) => m.name.toLowerCase().includes(t) || m.category.toLowerCase().includes(t)).slice(0, 12);
  }, [q, items]);
  return (
    <div className="relative" data-testid="po-menu-search">
      <Search className="absolute left-3 top-3.5 h-5 w-5 text-[#a8781f]" />
      <Input className="h-12 pl-10 text-base" placeholder="Search dish — e.g. Puranpoli, Misal…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="po-menu-search-input" />
      {hits.length > 0 && (
        <div className="absolute z-20 mt-1 w-full max-h-72 overflow-y-auto rounded-xl border-2 border-[#e2b85a] bg-white shadow-lg">
          {hits.map((m) => (
            <button key={m.key} type="button" className="flex w-full items-center justify-between gap-2 px-4 py-3 text-left hover:bg-[#fff6df]"
              onClick={() => { onAdd(m); setQ(""); }} data-testid={`po-menu-hit-${m.key}`}>
              <span><span className="font-semibold">{m.name}</span>{m.serves && <span className="text-sm text-muted-foreground"> · {m.serves}</span>}</span>
              <span className="flex items-center gap-2 font-semibold text-[#7a0f1d]">{sym}{m.price}<Plus className="h-4 w-4" /></span>
            </button>))}
        </div>)}
      {q.trim() && !hits.length && <p className="mt-1 text-sm text-muted-foreground">No dish found on this centre's menu.</p>}
    </div>
  );
}
